import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FormBuilderService } from '../../../services';

@Component({
	selector: 'app-lookup-data-detail',
	templateUrl: './lookup-data-detail.component.html',
	styleUrls: [ './lookup-data-detail.component.scss' ]
})
export class LookupDataDetailComponent implements OnInit {
	pending: boolean;
	success: any;
	error: any;
	fieldArrays: Array<any> = [];
	constructor(
		private location: Location,
		private modalService: SuiModalService,
		private formBuilder: FormBuilderService
	) {}
	goBack() {
		this.location.back();
	}

	ngOnInit(): void {}
}
